import { Model as s } from "../../../model.js";
class t extends s {
  constructor(i) {
    super(), this.id = i.id, this.locationId = i.locationId, this.status = i.status, this.settings = i.settings, this.checkout = i.checkout, this.delivery = i.delivery, this.configuration = i.configuration, this.ospaVersion = i.ospaVersion, this.service = i.service, this.landing = i.landing, this.timezone = i.timezone, this.trackingPageUrl = i.trackingPageUrl;
  }
}
export {
  t as ShopSessionModel
};
//# sourceMappingURL=shopSession.model.js.map
